import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import router from 'src/router';
import AppInit from './components/AppInit';
import ThemeProvider from './theme/ThemeProvider';

function App() {
  const content = useRoutes(router);
  const auth = useAuth();
  const { logout, user } = useAuth() as any;
  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const [userType, setUserType] = useState(localStorage.getItem('userType'));
  const jwtToken = window.localStorage.getItem('jwtToken');

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'userType') {
        setUserType(event.newValue);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (!jwtToken && currentUrl) {
      logout();
    }
  }, [jwtToken, currentUrl]);

  useEffect(() => {
    const VendorLogin = window.location.href.split('/')[6];
    if (VendorLogin === 'fromcustomerportal') {
      logout();
      registerUrl();
    }
  }, []);

  const registerUrl = () => {
    navigate(`/account/vendor/register/${'fromvendorportal'}`);
  };

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider
          maxSnack={6}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <CssBaseline />
          {auth.isInitialized ? content : <AppInit />}
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
